/**
 * Types for export validation
 * Defines interfaces and enums for validating exportable data
 */

export enum DataEmptyReason {
  NO_ROWS = "no_rows",
  NO_FILTERS_APPLIED = "no_filters_applied",
  INVALID_STATE = "invalid_state",
  UNKNOWN = "unknown",
}

export enum BackendErrorCode {
  NO_DATA_AVAILABLE = "NO_DATA_AVAILABLE",
  INVALID_PARAMETERS = "INVALID_PARAMETERS",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export interface ExportValidationResult {
  isValid: boolean;
  message?: string;
  reason?: DataEmptyReason;
  rowCount?: number;
}

export type ExportApiResponse = {
  code?: string;
  error?: string;
  id?: number;
  task_id?: string;
  file_url?: string;
  status?: string;
} | Array<{
  code?: string;
  error?: string;
}>;

export interface ExportValidationConfig {
  enableLogging?: boolean;
  customMessages?: {
    noData?: string;
    invalidState?: string;
  };
}

